export const languageElements = {
  items: {
    "form-title": {
      hu: "Első belépés",
      de: "Erste Anmeldung",
      en: "First login",
    },
  },
};
